export enum HoldEventType {
  Other,
  Personal,
  Maintenance,
  Pending,
  Confirmed,
}

export const holdEventTypes = [
  { id: HoldEventType.Other, name: $localize`Other` },
  { id: HoldEventType.Personal, name: $localize`Personal` },
  { id: HoldEventType.Maintenance, name: $localize`Maintenance` },
  { id: HoldEventType.Pending, name: $localize`Pending` },
  { id: HoldEventType.Confirmed, name: $localize`Confirmed` },
]
